module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nvar acceptTracking = null;\nif(((storage.session.data || {}).cookiePolicy || {}).acceptTracking !== null) {\nacceptTracking = storage.session.data.cookiePolicy.acceptTracking;\n}\n%><div<%- acceptTracking !== null ? ' class=\"disabled\"' : '' %>>\n<div class=\"closeBut\">&times;</div>\n<div class=\"container\">\n<div class=\"title\"><%= model.title; %></div>\n<div class=\"info\"><%- model.info; %></div>\n<div class=\"buttons-container\">\n<button data-type=\"accept\"><%= model.buttonAcceptText; %></button>\n<button data-type=\"deny\"><%= model.buttonDenyText; %></button>\n</div>\n<nav><%- model.nav; %></nav>\n</div>\n</div>"
  , __filename = "components/templates/privacyOverlay/privacyOverlay.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
var acceptTracking = null;
if(((storage.session.data || {}).cookiePolicy || {}).acceptTracking !== null) {
acceptTracking = storage.session.data.cookiePolicy.acceptTracking;
}

    ; __line = 6
    ; __append("<div")
    ; __append( acceptTracking !== null ? ' class="disabled"' : '' )
    ; __append(">\n<div class=\"closeBut\">&times;</div>\n<div class=\"container\">\n<div class=\"title\">")
    ; __line = 9
    ; __append(escapeFn( model.title ))
    ; __append("</div>\n<div class=\"info\">")
    ; __line = 10
    ; __append( model.info )
    ; __append("</div>\n<div class=\"buttons-container\">\n<button data-type=\"accept\">")
    ; __line = 12
    ; __append(escapeFn( model.buttonAcceptText ))
    ; __append("</button>\n<button data-type=\"deny\">")
    ; __line = 13
    ; __append(escapeFn( model.buttonDenyText ))
    ; __append("</button>\n</div>\n<nav>")
    ; __line = 15
    ; __append( model.nav )
    ; __append("</nav>\n</div>\n</div>")
    ; __line = 17
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/privacyOverlay/privacyOverlay.ejs

}